/**
 * EAA-2090: the access/refresh JWTs are HttpOnly cookies set by the API, so JS never reads them.
 * Only a non-secret hint is kept here, telling a page reload to ask /auth/user/ (the real check)
 * whether the cookie session is still valid.
 */
const SESSION_HINT_KEY = 'has_session';

/** Keys older builds stored the raw JWTs under; read once to move the session to cookies, then removed. */
const LEGACY_ACCESS_KEY = 'access';
const LEGACY_REFRESH_KEY = 'refresh';

export const hasSessionHint = (): boolean =>
    localStorage.getItem(SESSION_HINT_KEY) === '1' || !!localStorage.getItem(LEGACY_REFRESH_KEY);

export const markSessionHint = (): void => {
    localStorage.setItem(SESSION_HINT_KEY, '1');
};

/** Returns the refresh token an older build left in localStorage (if any) and removes both legacy keys. */
export const takeLegacyRefreshToken = (): string | null => {
    const refresh = localStorage.getItem(LEGACY_REFRESH_KEY);
    localStorage.removeItem(LEGACY_ACCESS_KEY);
    localStorage.removeItem(LEGACY_REFRESH_KEY);
    return refresh;
};

export const clearSessionHint = (): void => {
    localStorage.removeItem(SESSION_HINT_KEY);
    localStorage.removeItem(LEGACY_ACCESS_KEY);
    localStorage.removeItem(LEGACY_REFRESH_KEY);
};
